import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { AuthGuard } from './auth-guard/services/auth.guard'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'manage-deductions/new-remittance',
    // canActivate: [AuthGuard],
  },
  {
    path: 'login',
    pathMatch: 'full',
    redirectTo: '',
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/main-dashboard/main-dashboard.module').then(
        (m) => m.MainDashboardModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'manage-deductions',
    loadChildren: () =>
      import('./modules/manage-deduction/manage-deduction.module').then(
        (m) => m.ManageDeductionModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'report',
    loadChildren: () =>
      import('./modules/reporting/reporting.module').then(
        (m) => m.ReportingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'connector',
    loadChildren: () =>
      import('./modules/connector/connector.module').then(
        (m) => m.ConnectorModule
      ),
    canActivate: [AuthGuard],
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
